export const validateMessages = {
  required: "${label} is required",
  types: {
    email: "${label} is not a valid email",
    number: "${label} is not a valid number",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

export const ADVISOR_CONTENT = [
  "Project Identification and Scope",
  "Feasibility and Site Assessment",
  "Financial and Economic Analysis",
  "Regulatory and Compliance",
  "Project Implementation and Timeline",
  "Operations Maintenance and Monitoring",
];

export const THEORY_OF_CHANGE_CONTENT = [
  "Goal Statement Review",
  "Log-frame Review/IRMF",
  "Barriers and Risks Review",
  "Assumptions Validation",
  "Enhanced Log-frame",
];

export const NO_OBJECTION_PROCEDURE_CONTENT = [
  "Project Overview",
  "National Alignment",
  "Sector Plan Alignment",
  "Technical Feasibility",
  "Financial and Economic Viability",
  "Environmental and Social Impacts",
  "Stakeholder Engagement",
];

export const NO_OBJECTION_PROCEDURE_PERCENTAGE = [
  "14%",
  "28%",
  "42%",
  "56%",
  "70%",
  "85%",
  "100%",
];

export const RATIONAL_ADVISOR = [
  { section: "Identification", step: 1, percentage: "20%" },
  { section: "Response", step: 3, percentage: "60%" },
  { section: "National Alignment", step: 4, percentage: "80%" },
  { section: "Monitoring and Evaluation", step: 5, percentage: "100%" },
];

export const RATIONAL_ADVISOR_SUBTABS = {
  Identification: [], // ["1.1 Identification (Cross-cutting)"], // Commented out to hide this section
  //Response: ["2.1 Potential Barriers"],
  Response: [],
  "National Alignment": [],
  "Monitoring and Evaluation": [],
};

export const EVALUATE_CONTENT = [
  "B.1 Context and Baseline",
  "B.2 Project/Programme Description",
  "B.3 Expected Results: Impact & Paradigm Shift",
  "B.4 Engagement Among Stakeholders",
  "C.1 Indicative Finance",
  "C.2 Justification of GCF Funding Request",
  "C.3 Sustainability and Replicability",
];

export const EVALUATE_SUBTABS = {
  "B. Proposal Executive Summary": [],
  "C. Proposal Information": [
    "C.1 Climate Change Context",
    "C.2 Proposed Project/Programme",
    "C.3 Country Ownership and Engagement with Stakeholders",
    "C.4 Indicative Safeguards Profile",
    "C.5 Exit Strategy and Sustainability of Impacts",
  ],
  "D. Indicative Financing Information": [
    "D.1 Total Financing ",
    "D.2 Indicative Terms Non-Grants Only",
    "D.3 Financial Structure",
    "D.4 Justification of GCF Funding Request",
  ],
  "E. Accredited Entity/Executing Entity Information": [],
  "F. Key Risks/Mitigation Measures": [],
  "G. Annexes": [
    "G.1 Map Indicating Project Location",
    "G.2 Pre-feasibility Study",
    "G.3 Results of E&S Risk Screening",
    "G.4 Theory of Change Diagram",
    "G.5 Simplified Economic and Financial Model",
    "G.6 Evidence of NDA Support",
  ],
};

export const PROJECT_CONTENT = {
  "context-and-baseline-form": {
    percent: "0%",
    conceptNoteSection: "B.1 Context and Baseline",
  },
  "context-and-baseline-results": {
    percent: "8%",
    conceptNoteSection: "B.1 Context and Baseline",
  },
  "project-description-form": {
    percent: "8%",
    conceptNoteSection: "B.2 Project Description",
  },
  "project-description-results": {
    percent: "16%",
    conceptNoteSection: "B.2 Project Description",
  },
  "project-results-gcf-form": {
    percent: "16%",
    conceptNoteSection: "B.3 Expected Project Results",
  },
  "project-result-gcf-results": {
    percent: "24%",
    conceptNoteSection: "B.3 Expected Project Results",
  },
  "project-results-gcf-form-24": {
    percent: "24%",
    conceptNoteSection: "B.3 Expected Project Results",
  },
  "project-result-gcf-results-32": {
    percent: "32%",
    conceptNoteSection: "B.3 Expected Project Results",
  },
  "project-results-gcf-form-32": {
    percent: "32%",
    conceptNoteSection: "B.3 Expected Project Results",
  },
  "project-result-gcf-results-40": {
    percent: "40%",
    conceptNoteSection: "B.3 Expected Project Results",
  },
  "project-results-gcf-form-40": {
    percent: "40%",
    conceptNoteSection: "B.3 Expected Project Results",
  },
  "project-result-gcf-results-48": {
    percent: "48%",
    conceptNoteSection: "B.3 Expected Project Results",
  },
  "project-results-gcf-form-48": {
    percent: "48%",
    conceptNoteSection: "B.3 Expected Project Results",
  },
  "project-result-gcf-results-56": {
    percent: "56%",
    conceptNoteSection: "B.3 Expected Project Results",
  },
  "project-results-gcf-form-56": {
    percent: "56%",
    conceptNoteSection: "B.3 Expected Project Results",
  },
  "project-result-gcf-results-64": {
    percent: "64%",
    conceptNoteSection: "B.3 Expected Project Results",
  },
  "nda-ae-form-64": {
    percent: "64%",
    conceptNoteSection: "B.4 Engagement Among Stakeholders",
  },
  "gcf-justification-form-72": {
    percent: "72%",
    conceptNoteSection: "C.2 Justification of Funding",
  },
  "nda-ae-results-72": {
    percent: "72%",
    conceptNoteSection: "B.4 Engagement Among Stakeholders",
  },
  "gcf-justification-results-90": {
    conceptNoteSection: "C.2 Justification of Funding",
    percent: "90%",
  },
  "sustainability-replicability-form-90": {
    percent: "100%",
    conceptNoteSection: "C.3 Sustainability and Replicability",
  },
  "sustainability-replicability-results-100": {
    percent: "100%",
    conceptNoteSection: "C.3 Sustainability and Replicability",
  },
};

export const THEORY_OF_CHANGE_PERCENTAGE = ["24%", "48%", "64%", "76%", "100%"];
export const EVALUATE_PERCENTAGE = [
  "8%",
  "14%",
  "21%",
  "29%",
  "34%",
  "43%",
  "50%",
  "57%",
  "64%",
  "71%",
  "78%",
  "85%",
  "92%",
  "100%",
];
